module.exports = __webpack_public_path__ + "media/23.4b18ebfa.mp3";